<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-content style="text-align: center;">
						<img src="@/assets/img/404.png" style="max-width: 500px"><br>
						<router-link to="/">
							<md-button class="md-primary">Go back</md-button>
						</router-link>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue